export const MAIN_ROUTE = '/';
export const PRODUCT_ROUTE = '/product';

export const DEFAULT_COLLECTION_ID = 'lexus';
